module.exports = __webpack_public_path__ + "static/media/info.54f59644.svg";